"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeSlider = void 0;
const react_1 = __importStar(require("react"));
const RangeSlider_styles_1 = require("./RangeSlider.styles");
const RangeSlider = ({ min, max, onChange, name: entityName, step }) => {
    const [minVal, setMinVal] = (0, react_1.useState)(min);
    const [maxVal, setMaxVal] = (0, react_1.useState)(max);
    const minValRef = (0, react_1.useRef)(null);
    const maxValRef = (0, react_1.useRef)(null);
    const range = (0, react_1.useRef)(null);
    const minText = (0, react_1.useRef)(null);
    const maxText = (0, react_1.useRef)(null);
    const [zIndex, setZIndex] = (0, react_1.useState)(4);
    (0, react_1.useEffect)(() => {
        setMinVal(min);
    }, [min]);
    (0, react_1.useEffect)(() => {
        setMaxVal(max);
    }, [max]);
    const getPercent = (0, react_1.useCallback)((value) => Math.round(((value - min) / (max - min)) * 100), [min, max]);
    (0, react_1.useEffect)(() => {
        if (!maxValRef.current || !minValRef.current) {
            return;
        }
        if (+minValRef.current.value > +maxValRef.current.value) {
            return;
        }
        const minPercent = Math.min(getPercent(maxVal), getPercent(+minValRef.current.value));
        const maxPercent = Math.max(getPercent(maxVal), getPercent(+minValRef.current.value));
        if (range.current) {
            range.current.style.left = `${minPercent}%`;
            range.current.style.width = `${maxPercent - minPercent}%`;
        }
        if (minText.current && minVal <= maxVal) {
            minText.current.style.left = `${minPercent}%`;
        }
        if (maxText.current && maxVal >= minVal) {
            maxText.current.style.left = `${maxPercent}%`;
        }
    }, [getPercent, maxVal, minVal]);
    (0, react_1.useEffect)(() => {
        if (minVal > maxVal) {
            return;
        }
        onChange({ min: minVal, max: maxVal });
    }, [minVal, maxVal, onChange]);
    return (react_1.default.createElement(RangeSlider_styles_1.Container, null,
        react_1.default.createElement(RangeSlider_styles_1.Slider, null,
            react_1.default.createElement(RangeSlider_styles_1.LimitWrapper, null,
                react_1.default.createElement(RangeSlider_styles_1.SliderLeftValue, { ref: minText },
                    "Min: ",
                    Math.min(minVal, maxVal),
                    entityName && entityName),
                react_1.default.createElement(RangeSlider_styles_1.SliderRightValue, { ref: maxText },
                    "Max: ",
                    Math.max(minVal, maxVal),
                    entityName && `${entityName}s`)),
            react_1.default.createElement(RangeSlider_styles_1.SliderTrack, null),
            react_1.default.createElement(RangeSlider_styles_1.SliderRange, { ref: range }),
            react_1.default.createElement(RangeSlider_styles_1.Input, { type: "range", min: min, max: max, step: step, value: minVal, ref: minValRef, onChange: (event) => {
                    const parsedValue = +event.target.value;
                    if (parsedValue > +maxVal) {
                        return;
                    }
                    setMinVal(parsedValue);
                    if (parsedValue === max) {
                        setZIndex(5);
                    }
                    else {
                        setZIndex(4);
                    }
                }, "$zIndex": zIndex }),
            react_1.default.createElement(RangeSlider_styles_1.Input, { type: "range", min: min, max: max, step: step, value: maxVal, ref: maxValRef, onChange: (event) => {
                    const parsedValue = +event.target.value;
                    if (parsedValue < +minVal) {
                        return;
                    }
                    setMaxVal(parsedValue);
                } }))));
};
exports.RangeSlider = RangeSlider;
//# sourceMappingURL=RangeSlider.js.map